import styled from "styled-components";

export const StyledRoleGuardWrapper = styled.span`
  * {
    pointer-events: none;
  }
  opacity: 0.4;
`;
